import {
  USER_CAMPAIGN_KEY,
  USER_CONTENT_KEY,
  USER_MEDIUM_KEY,
  USER_SOURCE_KEY,
} from "@hopper-b2b/utilities";

/**
 * Maps URL parameter keys to standardized tracking keys
 * Supports both utm_* and direct parameter names
 */
export const ParamToKey = {
  [USER_CAMPAIGN_KEY]: USER_CAMPAIGN_KEY,
  utm_campaign: USER_CAMPAIGN_KEY,
  [USER_MEDIUM_KEY]: USER_MEDIUM_KEY,
  utm_medium: USER_MEDIUM_KEY,
  [USER_SOURCE_KEY]: USER_SOURCE_KEY,
  utm_source: USER_SOURCE_KEY,
  [USER_CONTENT_KEY]: USER_CONTENT_KEY,
  utm_content: USER_CONTENT_KEY,
};

// Re-export tracking utilities
export * from "./tracking/calendarTracking";
export * from "./tracking/filterTracking";
export * from "./tracking/paymentTracking";
